import React, { useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import './signupform.css'
import Interra from "../images/logo.png";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'
import { auth } from '../firebase'
import { toast } from 'react-toastify';

function SignupForm() {
    const navi = useNavigate();
    const [Name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    // const [brand, setBrand] = useState(true);
    // const [influencer, setInfluencer] = useState(false);
    const [isBrand, setIsBrand] = useState(true);
    let myObj =
    {
        name: Name,
        email: email,
        pass: password,
        conPass: confirmPassword,
        userType: isBrand ? "brand" : "influencer"
    }
    function ClickLogo() {
        let path = `/`;
        navi(path);
    }
    const userCollectionReference = collection(db, "USER_REG")

    // This function is used to add the user to the database
    const createUser = async (e) => {

        /*
            Storing to the USER_EMAIL_PASS collection
        */

        //regex for email
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //test for email using regex
        const isEmailValid = emailRegex.test(email);

        if (!Name || !email || !password || !confirmPassword) {
            toast.warn('Fill Up empty Fields ', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else if (confirmPassword !== password) {
            toast.warn('Passwords do not match', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });


        }

        else if (isEmailValid === false) {

            toast.warn('Email Address Invalid', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {

            // console.log("User added to the database");
            toast.success('Registered Successfully ', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            e.preventDefault();
            try {
                await addDoc(userCollectionReference, myObj)
                if (isBrand) {
                    navi("/brand-details")
                }
                else {
                    navi("/influencer-details")
                }
                console.log("User added to the database");
            } catch (error) {
                console.log(error.message);
            }

            isBrand ? navi("/brand-details") : navi("/influencer-details");

        }
    }

    /*
       Storing to the USER_REG collection
       Collection refernce and payload is passed to the addDoc function
   */



    // console.log(myObj);
    // const handleInputChange = (e) => {
    //     const { id, value } = e.target;
    //     if (id === "brandName") {
    //         setBrandName(value);
    //     }
    //     if (id === "influencerName") {
    //         setInfluencerName(value);
    //     }
    //     if (id === "email") {
    //         setEmail(value);
    //     }
    //     if (id === "password") {
    //         setPassword(value);
    //     }
    //     if (id === "confirmPassword") {
    //         setConfirmPassword(value);
    //     }

    // }

    // const handleSubmit = () => {

    //     brand === true ? console.log(brandName, email, password, confirmPassword) : console.log(influencerName, email, password, confirmPassword);
    // }

    // const handleBrand = () => {
    //     setBrand(true)
    //     setInfluencer(false)
    // }

    // const handleInfluencer = () => {
    //     setBrand(false)
    //     setInfluencer(true)
    // }


    return (
        <div className='outerdiv1'>
            <img src={Interra} className="logo" onClick={ClickLogo}></img>
            {/* <img src="/images/image 3.jpg" alt="Logo" className='img1'></img> */}
            <button onClick={() => { setIsBrand(true) }} type="button" className="brand_user active" >Brand</button>
            <button onClick={() => { setIsBrand(false) }} type="button" className="influencer_user">Influencer</button>
            <div className='box2'>
                <div className="form">
                    <div className='column'>
                        <div className="form-body">
                            {isBrand ?
                                <div className="brandname">
                                    <PersonIcon className="icon1" />
                                    <input className="form__input" type="text" value={Name} onChange={(e) => setName(e.target.value)} id="brandName" placeholder="Brand Name" />
                                </div>
                                :
                                <div className="influencername">
                                    <PersonIcon className="icon1" />
                                    <input className="form__input" type="text" value={Name} onChange={(e) => setName(e.target.value)} id="influencerName" placeholder="Influencer Name" />
                                </div>
                            }

                            <div className="email1">
                                <EmailIcon className='icon1' />
                                <input type="email" id="email" className="form__input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
                            </div>
                            <div className="password">
                                <LockIcon className="icon1" />
                                <input className="form__input" type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
                            </div>
                            <div className="confirm-password">
                                <LockIcon className='icon1' />
                                <input className="form__input" type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm Password" />
                            </div>
                            <div className="condition">
                                <input type="radio" id="conditions" name="conditions" value="conditions" />
                                <label for="html">agree to terms and conditions</label>
                            </div>

                            <div class="footer" onClick={createUser} >
                                <button style={{ color: "black" }} type="submit" class="btn-register">
                                    Register
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='column'>
                        <img src="/images/signup_logo2.png" alt="Logo" className="signup_logo1"></img>
                    </div>
                </div>
            </div>

        </div>

    )

}
export default SignupForm